import React, { Fragment } from 'react';
import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const InfoTitle = styled.h3`
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 25px;
    text-align: center;
    width: 100%;
`;
export const InfoText = styled.div`
    font-size: 16px;
    line-height: 24px;
    margin: 0 auto 50px;
    text-align: center;
    width: 100%;
    max-width: 930px;
    justify-content: center;
`;
export const InfoTextGrey = styled(InfoText)`
    color: ${ COLORS.darkGrey };
    margin-bottom: 30px;
`;
export const InfoBlock = styled.div`
    background: ${ COLORS.white };
    border: 1px solid ${ COLORS.outlineGrey };
    box-sizing: border-box;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    padding: 60px 50px 50px;
    margin-bottom: 35px;
    width: 100%;
    @media (max-width: 1400px) {
        padding: 60px 40px 50px;
    }
    @media (max-width: 900px) {
        padding: 60px 30px 50px;
    }
`;
export const InfoBlockTitle = styled.div`
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 40px;
    font-family: 'robotoRegular', Arial, Helvetica, sans-serif;
    justify-content: center;    
    text-align: center;
`;
export const InfoBlockList = styled.div`
    display: flex;
    flex-wrap: nowrap;
    @media (max-width: 900px) {
        flex-direction: column;
    }
`;
export const InfoBlockListColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    padding-right: 25px;
    justify-content: space-between;
    @media (max-width: 1400px) {
        padding-right: 20px;
    }
    @media (max-width: 900px) {
        width: 100%;
        padding: 0 0 0 20px;
    }
    @media (max-width: 500px) {
        padding: 0;
    }
`;
export const InfoBlockListColumnRight = styled(InfoBlockListColumn)`
    padding: 0 0 0 25px;
    @media (max-width: 1400px) {
       padding: 0 0 0 20px;
    }
    @media (max-width: 900px) {
        width: 100%;
        padding: 20px 0 0 20px;
    }
    @media (max-width: 500px) {
        padding: 20px 0 0;
    }
`;
export const InfoBlockItem = styled.div`
    font-size: 16px;
    line-height: 24px;
    padding: 35px 0 0 30px;
    :before {
        content: '•';
        position: absolute;
        font-size: 30px;
        margin-left: -15px;        
    }
    :first-child {
      padding: 0 0 0 30px;
    }
    @media (max-width: 900px) {
        padding: 20px 0 0 10px;
        :first-child {
          padding: 0 0 0 10px;
        }
    }
    @media (max-width: 500px) {
        padding: 20px 0 0 0;
        :first-child {
          padding: 0;
        }
    }
`;

export const Info = (props) => {
    const { city } = props;

    return (
        <Fragment>
            <InfoTitle>Интернет в каждом уголке квартиры</InfoTitle>
            <InfoText>
                Для того, чтобы пользоваться интернетом с нескольких устройств, вам понадобится Wi-Fi-роутер.
                С этим оборудованием вы можете быть онлайн с ноутбука, телефона, планшета одновременно.
                И не нужно тянуть интернет-кабель для каждого.
            </InfoText>
            <InfoBlock>
                <InfoBlockTitle>Выберите Wi-Fi-роутер для домашнего интернета в квартиру</InfoBlockTitle>
                <InfoBlockList>
                    <InfoBlockListColumn>
                        <InfoBlockItem>
                            Если у вас однокомнатная квартира, и вы сидите в сети с ноутбука и телефона,
                            вам подойдет роутер для 6 устройств.
                        </InfoBlockItem>
                        <InfoBlockItem>
                            Если у вас 2-3 комнаты, мы установим такое оборудование, чтобы интернет ловил в каждой.
                            К нему можно подключить 10 устройств.
                        </InfoBlockItem>
                        <InfoBlockItem>
                            Инженеры Дом.ru изучат планировку и установят оборудование так, чтобы ловило везде —
                            от кухни до балкона.
                        </InfoBlockItem>
                        <InfoBlockItem>
                            У каждого роутера два диапазона: 2,4 ГГц и 5 ГГц. Одной кнопкой включите диапазон 5 ГГц
                            и получите скорость без помех от соседних сетей и бытовых приборов.
                        </InfoBlockItem>
                    </InfoBlockListColumn>
                    <InfoBlockListColumnRight>
                        <InfoBlockItem>
                            Для 4-х комнат и более рекомендуем модель, которая поддерживает скорость 600 Мбит/сек.
                            С ней можно использовать одновременно 15 устройств.
                        </InfoBlockItem>
                        <InfoBlockItem>
                            Для дома с большой площадью и сложной планировкой подойдут домашняя сеть Wi-Fi или
                            Wi-Fi Mesh-система.
                        </InfoBlockItem>
                        <InfoBlockItem>
                            Мы правильно установим Wi-Fi-оборудование без вреда интерьеру.
                            Сигнал будет стабильный в любой точке квартиры дни и ночи напролет.
                            Видеосвязь не прервется, загрузка файла не остановится, а фильмы,
                            сериалы и игры не будут зависать.
                        </InfoBlockItem>
                    </InfoBlockListColumnRight>
                </InfoBlockList>
            </InfoBlock>
            <InfoTextGrey>Купить Wi-Fi-роутеры в { city.cityIn } можно на сайте Дом.ru, не выходя из
                дома.</InfoTextGrey>
        </Fragment>
    );
};
